var map = {
	"./sa/label/index.vue": [
		"245b",
		"label0"
	],
	"./sic/label/index.vue": [
		"7d1c",
		"label1"
	],
	"./sm/label/index.vue": [
		"b658",
		"label2"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "0e37";
module.exports = webpackAsyncContext;